import { useSessionState } from '../../shared/hooks/session-state-hook';
import { sessionKey } from '../../shared/util/session-storage';
import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import Card from '../../shared/components/UIElements/Card';
import Button from '../../shared/components/FormElements/Button';
import Modal from '../../shared/components/UIElements/Modal';
import './PatientViewItem.css';
import { AuthContext } from '../../shared/Context/auth-context';

const PatientViewItem = (props) => {
  const auth = useContext(AuthContext);
  const history = useHistory();

  const createPrescriptionHandler = () => {
    history.push(`/`);
  };
  const [showHistoryModal, setShowHistoryModal] = useSessionState(
    sessionKey(`doctor:${auth.doctorId}`, `history:${props.id}:open`),
    false
  );

  const openHistoryHandler = () => setShowHistoryModal(true);
  const closeHistoryHandler = () => setShowHistoryModal(false);

  return (
    <React.Fragment>
      <Modal
        show={showHistoryModal}
        onCancel={closeHistoryHandler}
        header="Patient History"
        footer={<Button onClick={closeHistoryHandler}>Close</Button>}
      >
        <div className="place-item__modal-content">
          {props.history.map((entry, idx) => (
            <Card key={idx} style={{ marginBottom: '1rem' }}>
              <h3>Condition: {entry.condition}</h3>
              <p>
                <strong>Medication:</strong>
              </p>
              <ul style={{ marginLeft: '1rem' }}>
                {entry.medication.map((med, mIdx) => (
                  <li key={mIdx}>
                    {med.name} ({med.dose}) – {med.duration}, {med.frequency}
                  </li>
                ))}
              </ul>
              <p>
                <strong>Remarks:</strong> {entry.remarks}
              </p>
              <p>
                <strong>Doctor:</strong> {entry.doctorName}
              </p>
              <p>
                <strong>Email:</strong> {entry.doctorEmail}
              </p>
              {entry.createdAt && (
                <p>
                  <strong>Date:</strong> {new Date(entry.createdAt).toLocaleString()}
                </p>
              )}
            </Card>
          ))}
        </div>
      </Modal>

      <li className="place-item">
        <Card className="place-item__content">
          <div className="place-item__info">
            <h2>{props.name}</h2>
            <h3>ID: {props.id}</h3>
          </div>
          <div className="place-item__actions">
            <Button inverse to={`/care/patients/${props.id}`}>
              Shared care timeline
            </Button>
            <Button
              inverse
              onClick={openHistoryHandler}
              disabled={!props.history || props.history.length === 0}
            >
              View history
            </Button>
            <Button to={`/${auth.doctorId}/prescribe/${props.id}`}>Create prescription</Button>
            <Button inverse to={`/reports/${props.id}`} onClick={createPrescriptionHandler}>
              Health reports
            </Button>
          </div>
        </Card>
      </li>
    </React.Fragment>
  );
};

export default PatientViewItem;
